import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Statements() {
  const nav = useNavigate();
  const [statementType, setStatementType] = useState('company');
  const [customers, setCustomers] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [banks, setBanks] = useState([]);
  const [trucks, setTrucks] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [selectedSupplier, setSelectedSupplier] = useState('');
  const [selectedBank, setSelectedBank] = useState('');
  const [selectedTruck, setSelectedTruck] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [statement, setStatement] = useState(null);
  const [loading, setLoading] = useState(false);

  // const API_BASE = "http://localhost:8000";
  const API_BASE = "https://www.fleetapi.exhibitsolutions.co.ke";
  // const API_BASE = "https://abbebehauliers.fleetapi.exhibitsolutions.co.tz";
  // const API_BASE="http://192.168.100.9:8000 ";
  
  

  useEffect(() => {
    fetchCustomersAndSuppliers();
    fetchBanks();
    fetchTrucks();
  }, []);

  const fetchCustomersAndSuppliers = async () => {
    try {
      const [customersRes, suppliersRes] = await Promise.all([
        fetch(`${API_BASE}/truck-finance/customers`),
        fetch(`${API_BASE}/truck-finance/suppliers`)
      ]);

      const customersData = await customersRes.json();
      const suppliersData = await suppliersRes.json();

      if (customersData.success) setCustomers(customersData.customers);
      if (suppliersData.success) setSuppliers(suppliersData.suppliers);
    } catch (error) {
      console.error("Error fetching customers/suppliers:", error);
    }
  };

  const fetchBanks = async () => {
    try {
      const banksRes = await fetch(`${API_BASE}/truck-finance/banks`);
      const banksData = await banksRes.json();
      if (banksData.success) setBanks(banksData.banks);
    } catch (error) {
      console.error("Error fetching banks:", error);
    }
  };

  const fetchTrucks = async () => {
    try {
      const trucksRes = await fetch(`${API_BASE}/vehicles/all-vehicles`);
      const trucksData = await trucksRes.json();
      if (trucksData.docs) {
        const formattedTrucks = trucksData.docs.map(vehicle => ({
          id: vehicle.id.toString(),
          plate_no: vehicle.plate_no,
          model: vehicle.make,
          fleet_no: vehicle.fleet_no
        }));
        setTrucks(formattedTrucks);
      }
    } catch (error) {
      console.error("Error fetching trucks:", error);
    }
  };

  const handleGenerateStatement = async () => {
    // Validation
    if (statementType === 'customer' && !selectedCustomer) {
      alert('Please select a customer');
      return;
    }

    if (statementType === 'supplier' && !selectedSupplier) {
      alert('Please select a supplier');
      return;
    }

    if (statementType === 'truck' && !selectedTruck) {
      alert('Please select a truck');
      return;
    }

    if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
      alert('Start date cannot be after end date');
      return;
    }

    setLoading(true);
    try {
      let url = `${API_BASE}/truck-finance/statement/${statementType}?`;

      // Add parameters
      const params = new URLSearchParams();

      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);
      if (selectedBank && selectedBank !== 'All Banks') params.append('bank', selectedBank);
      if (selectedTruck && selectedTruck !== 'All Trucks') params.append('truckId', selectedTruck);

      if (statementType === 'customer' && selectedCustomer) {
        params.append('customer', selectedCustomer);
      } else if (statementType === 'supplier' && selectedSupplier) {
        params.append('supplier', selectedSupplier);
      } else if (statementType === 'truck' && selectedTruck) {
        params.append('truckId', selectedTruck);
      }

      url += params.toString();
      console.log("API URL:", url); // DEBUG: Check the URL being called

      const response = await fetch(url);
      const data = await response.json();

      console.log("API Response:", data); // DEBUG: Check the response

      if (data.success) {
        setStatement(data.statement);
      } else {
        alert(`Error: ${data.error}`);
      }
    } catch (error) {
      console.error("Error generating statement:", error);
      alert("Failed to generate statement");
    } finally {
      setLoading(false);
    }
  };

  const handleClearFilters = () => {
    setSelectedCustomer('');
    setSelectedSupplier('');
    setSelectedBank('');
    setSelectedTruck('');
    setStartDate('');
    setEndDate('');
    setStatement(null);
  };

  const handlePrint = () => {
    if (!statement) {
      alert("Please generate a statement first!");
      return;
    }

    const printWindow = window.open('', '_blank');
    const printContent = document.getElementById('statement-content').innerHTML;

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>${statement.type} Statement</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            margin: 20px;
            background: white;
            color: black;
          }
          .statement-container {
            max-width: 100%;
            margin: 0 auto;
          }
          .statement-header {
            border-bottom: 2px solid #333;
            padding-bottom: 20px;
            margin-bottom: 30px;
          }
          .statement-header h2 {
            font-size: 24px;
            margin: 0 0 10px 0;
          }
          .statement-info {
            font-size: 14px;
            margin: 5px 0;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin: 20px 0;
          }
          th, td {
            border: 1px solid #ddd;
            padding: 8px;
            text-align: left;
          }
          th {
            background-color: #f5f5f5;
            font-weight: bold;
          }
          .text-right {
            text-align: right;
          }
          .text-center {
            text-align: center;
          }
          .summary-section {
            margin-top: 30px;
            padding-top: 20px;
            border-top: 2px solid #333;
          }
          .summary-box {
            padding: 15px;
            margin: 10px 0;
            border-radius: 5px;
          }
          .green-text {
            color: #15803d;
          }
          .red-text {
            color: #dc2626;
          }
          .blue-text {
            color: #2563eb;
          }
          .bold {
            font-weight: bold;
          }
          .footer {
            margin-top: 50px;
            text-align: center;
            font-size: 12px;
            color: #666;
          }
          @media print {
            @page {
              margin: 0.5in;
            }
            body {
              font-size: 11px;
            }
            .no-print {
              display: none !important;
            }
            table {
              page-break-inside: auto;
            }
            tr {
              page-break-inside: avoid;
              page-break-after: auto;
            }
            thead {
              display: table-header-group;
            }
            tfoot {
              display: table-footer-group;
            }
          }
        </style>
      </head>
      <body>
        <div class="statement-container">
          ${printContent}
          <div class="footer">
            Generated on ${new Date().toLocaleDateString()} at ${new Date().toLocaleTimeString()}
          </div>
        </div>
        <script>
          window.onload = function() {
            window.print();
            setTimeout(function() {
              window.close();
            }, 100);
          }
        </script>
      </body>
      </html>
    `);

    printWindow.document.close();
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  // Helper function to get truck display name
  const getTruckDisplayName = (truckId) => {
    if (!truckId || truckId === 'All Trucks') return '';
    const truck = trucks.find(t => t.id === truckId);
    return truck ? `${truck.plate_no} - ${truck.model} ${truck.fleet_no ? `(${truck.fleet_no})` : ''}` : truckId;
  };

  return (
    <div className="p-8 bg-light_grey min-h-screen">
      <div className="flex gap-4 mb-8 no-print">
        <button className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-orange-500 transition duration-200 font-semibold" onClick={() => nav("/dashboard/finance")}>Finance</button>
        <button className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-orange-500 transition duration-200 font-semibold" onClick={() => nav("/dashboard/finance/statements")}>Statement</button>
        <button className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-orange-500 transition duration-200 font-semibold" onClick={() => nav("/dashboard/finance/trucks")}>Truck/Trella</button>
      </div>

      <h1 className="text-4xl font-bold mb-8 text-primary no-print">Statements Dashboard</h1>

      {/* Statement Type Selection */}
      <div className="bg-white rounded-lg shadow-md p-6 mb-8 no-print">
        <h2 className="text-2xl font-semibold mb-4">Generate Statement</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Statement Type</label>
            <select
              value={statementType}
              onChange={(e) => {
                setStatementType(e.target.value);
                setSelectedCustomer('');
                setSelectedSupplier('');
                setSelectedTruck('');
                setStatement(null);
              }}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            >
              <option value="company">Company Statement</option>
              <option value="customer">Customer Statement</option>
              <option value="supplier">Supplier Statement</option>
            </select>
          </div>

          {statementType === 'customer' && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Select Customer</label>
              <select
                value={selectedCustomer}
                onChange={(e) => setSelectedCustomer(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Select Customer</option>
                {customers.map(customer => (
                  <option key={customer} value={customer}>{customer}</option>
                ))}
              </select>
            </div>
          )}

          {statementType === 'supplier' && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Select Supplier</label>
              <select
                value={selectedSupplier}
                onChange={(e) => setSelectedSupplier(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Select Supplier</option>
                {suppliers.map(supplier => (
                  <option key={supplier} value={supplier}>{supplier}</option>
                ))}
              </select>
            </div>
          )}

          {statementType === 'truck' && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Select Truck *</label>
              <select
                value={selectedTruck}
                onChange={(e) => setSelectedTruck(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                required
              >
                <option value="">Select Truck</option>
                {trucks.map(truck => (
                  <option key={truck.id} value={truck.id}>
                    {truck.plate_no} - {truck.model} {truck.fleet_no ? `(${truck.fleet_no})` : ''}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Bank</label>
            <select
              value={selectedBank}
              onChange={(e) => setSelectedBank(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            >
              <option value="">All Banks</option>
              {banks.map(bank => (
                <option key={bank} value={bank}>{bank}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Start Date</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">End Date</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Add truck filter for other statement types */}
          {statementType !== 'truck' && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Filter by Truck (Optional)</label>
              <select
                value={selectedTruck}
                onChange={(e) => setSelectedTruck(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              >
                <option value="">All Trucks</option>
                {trucks.map(truck => (
                  <option key={truck.id} value={truck.id}>
                    {truck.plate_no} - {truck.model} {truck.fleet_no ? `(${truck.fleet_no})` : ''}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>

        <div className="flex gap-4">
          <button
            onClick={handleGenerateStatement}
            disabled={loading}
            className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition duration-200 font-semibold disabled:bg-gray-400 disabled:cursor-not-allowed"
          >
            {loading ? 'Generating...' : 'Generate Statement'}
          </button>

          <button
            onClick={handleClearFilters}
            className="bg-gray-300 text-gray-700 px-6 py-3 rounded-lg hover:bg-gray-400 transition duration-200 font-semibold"
          >
            Clear Filters
          </button>
        </div>
      </div>

      {/* Statement Display */}
      {statement && (
        <div className="bg-white rounded-lg shadow-md p-8 print:shadow-none print:p-0" id="statement-content">
          {/* Add print action buttons inside the statement */}
          <div className="flex justify-end gap-4 mb-6 no-print">
            <button
              onClick={handlePrint}
              className="bg-blue-800 text-white px-6 py-3 rounded-lg hover:bg-blue-900 transition duration-200 font-semibold"
            >
              Print Statement
            </button>
          </div>

          {/* Statement Header */}
          <div className="border-b-2 border-gray-300 pb-6 mb-6">
            <div className="flex justify-between items-start">
              <div>
                <h2 className="text-3xl font-bold mb-2">
                  {statement.type} Statement
                  {statement.truckPlate && ` - ${statement.truckPlate}`}
                </h2>
                {statement.customer && (
                  <p className="text-lg text-gray-700">Customer: <span className="font-semibold">{statement.customer}</span></p>
                )}
                {statement.supplier && (
                  <p className="text-lg text-gray-700">Supplier: <span className="font-semibold">{statement.supplier}</span></p>
                )}
                {statement.truckPlate && statement.type === 'Truck' && (
                  <p className="text-lg text-gray-700">Truck: <span className="font-semibold">{statement.truckPlate} ({statement.truckModel}) {statement.truckFleetNo ? `- ${statement.truckFleetNo}` : ''}</span></p>
                )}
                {selectedBank && selectedBank !== 'All Banks' && (
                  <p className="text-lg text-gray-700">Bank: <span className="font-semibold">{selectedBank}</span></p>
                )}
                {selectedTruck && selectedTruck !== 'All Trucks' && statement.type !== 'Truck' && (
                  <p className="text-lg text-gray-700">Truck Filter: <span className="font-semibold">{getTruckDisplayName(selectedTruck)}</span></p>
                )}
                {selectedTruck && selectedTruck !== 'All Trucks' && statement.type === 'Company' && (
                  <p className="text-lg text-gray-700 text-blue-600">✓ Filtering by selected truck only</p>
                )}
              </div>

              <div className="text-right">
                <p className="text-gray-600">
                  Generated: {new Date().toLocaleDateString()}
                </p>
                {(statement.startDate || statement.endDate) && (
                  <p className="text-gray-600 mt-1">
                    Period: {statement.startDate ? formatDate(statement.startDate) : 'Beginning'}
                    {' to '}
                    {statement.endDate ? formatDate(statement.endDate) : 'Present'}
                  </p>
                )}
                {selectedTruck && selectedTruck !== 'All Trucks' && (
                  <p className="text-gray-600 mt-1 text-green-600">
                    ✓ Filtered by: {getTruckDisplayName(selectedTruck)}
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* DEBUG INFO - REMOVE IN PRODUCTION */}
          {process.env.NODE_ENV === 'development' && (
            <div className="mb-4 p-3 bg-yellow-50 border border-yellow-200 rounded no-print">
              <p className="text-sm text-yellow-800">
                <strong></strong> Selected Truck ID: {selectedTruck} |
                Statement Type: {statement.type} |
                Total Deliveries: {statement.deliveries?.length || 0} |
                Total Expenses: {statement.expenses?.length || 0}
              </p>
            </div>
          )}

          {/* Company or Truck Statement */}
          {(statement.type === 'Company' || statement.type === 'Truck') && (
            <>
              <div className="mb-8">
                <h3 className="text-xl font-bold mb-4 text-green-700">Deliveries (Income)</h3>
                {statement.deliveries.length === 0 ? (
                  <p className="text-gray-500 text-center py-4 bg-gray-50 rounded-lg">
                    No deliveries found for the selected criteria
                    {selectedTruck && selectedTruck !== 'All Trucks' && (
                      <span className="block mt-2">for truck: {getTruckDisplayName(selectedTruck)}</span>
                    )}
                  </p>
                ) : (
                  <div className="overflow-x-auto">
                    <table className="min-w-full border-collapse border border-gray-300">
                      <thead className="bg-gray-100">
                        <tr>
                          <th className="border border-gray-300 px-4 py-2 text-left">Date</th>
                          <th className="border border-gray-300 px-4 py-2 text-left">Vehicle</th>
                          <th className="border border-gray-300 px-4 py-2 text-left">Route</th>
                          <th className="border border-gray-300 px-4 py-2 text-left">Customer</th>
                          <th className="border border-gray-300 px-4 py-2 text-left">Bank</th>
                          <th className="border border-gray-300 px-4 py-2 text-left">Description</th>
                          <th className="border border-gray-300 px-4 py-2 text-right">Amount (KSh)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {statement.deliveries.map((d) => (
                          <tr key={d.id} className="hover:bg-gray-50">
                            <td className="border border-gray-300 px-4 py-2">{new Date(d.date).toLocaleDateString()}</td>
                            <td className="border border-gray-300 px-4 py-2">{d.vehicles?.plate_no || 'N/A'}</td>
                            <td className="border border-gray-300 px-4 py-2">{d.from} → {d.to}</td>
                            <td className="border border-gray-300 px-4 py-2">{d.customer || '-'}</td>
                            <td className="border border-gray-300 px-4 py-2">{d.bank || '-'}</td>
                            <td className="border border-gray-300 px-4 py-2">{d.description || '-'}</td>
                            <td className="border border-gray-300 px-4 py-2 text-right font-semibold text-green-600">
                              {parseFloat(d.amount).toLocaleString()}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      {statement.deliveries.length > 0 && (
                        <tfoot>
                          <tr className="bg-gray-50">
                            <td colSpan="6" className="border border-gray-300 px-4 py-2 text-right font-bold">Total Deliveries:</td>
                            <td className="border border-gray-300 px-4 py-2 text-right font-bold text-green-600">
                              KSh {statement.totalIncome.toLocaleString()}
                            </td>
                          </tr>
                          {selectedTruck && selectedTruck !== 'All Trucks' && (
                            <tr className="bg-blue-50">
                              <td colSpan="7" className="border border-gray-300 px-4 py-2 text-center text-blue-700 font-semibold">
                                Showing {statement.deliveries.length} delivery(ies) for selected truck only
                              </td>
                            </tr>
                          )}
                        </tfoot>
                      )}
                    </table>
                  </div>
                )}
              </div>
              <div className="mb-8">
                <h3 className="text-xl font-bold mb-4 text-red-700">Expenses</h3>
                {statement.expenses.length === 0 ? (
                  <p className="text-gray-500 text-center py-4 bg-gray-50 rounded-lg">
                    No expenses found for the selected criteria
                    {selectedTruck && selectedTruck !== 'All Trucks' && (
                      <span className="block mt-2">for truck: {getTruckDisplayName(selectedTruck)}</span>
                    )}
                  </p>
                ) : (
                  <div className="overflow-x-auto">
                    <table className="min-w-full border-collapse border border-gray-300">
                      <thead className="bg-gray-100">
                        <tr>
                          <th className="border border-gray-300 px-4 py-2 text-left">Date</th>
                          <th className="border border-gray-300 px-4 py-2 text-left">Vehicle</th>
                          <th className="border border-gray-300 px-4 py-2 text-left">Supplier</th>
                          <th className="border border-gray-300 px-4 py-2 text-left">Bank</th>
                          <th className="border border-gray-300 px-4 py-2 text-left">Description</th>
                          <th className="border border-gray-300 px-4 py-2 text-right">Amount (KSh)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {statement.expenses.map((e) => (
                          <tr key={e.id} className="hover:bg-gray-50">
                            <td className="border border-gray-300 px-4 py-2">{new Date(e.date).toLocaleDateString()}</td>
                            <td className="border border-gray-300 px-4 py-2">{e.vehicles?.plate_no || 'N/A'}</td>
                            <td className="border border-gray-300 px-4 py-2">{e.supplier || '-'}</td>
                            <td className="border border-gray-300 px-4 py-2">{e.bank || '-'}</td>
                            <td className="border border-gray-300 px-4 py-2">{e.description || '-'}</td>
                            <td className="border border-gray-300 px-4 py-2 text-right font-semibold text-red-600">
                              {parseFloat(e.amount).toLocaleString()}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      {statement.expenses.length > 0 && (
                        <tfoot>
                          <tr className="bg-gray-50">
                            <td colSpan="5" className="border border-gray-300 px-4 py-2 text-right font-bold">Total Expenses:</td>
                            <td className="border border-gray-300 px-4 py-2 text-right font-bold text-red-600">
                              KSh {statement.totalExpenses.toLocaleString()}
                            </td>
                          </tr>
                          {selectedTruck && selectedTruck !== 'All Trucks' && (
                            <tr className="bg-blue-50">
                              <td colSpan="6" className="border border-gray-300 px-4 py-2 text-center text-blue-700 font-semibold">
                                Showing {statement.expenses.length} expense(s) for selected truck only
                              </td>
                            </tr>
                          )}
                        </tfoot>
                      )}
                    </table>
                  </div>
                )}
              </div>

              <div className="border-t-2 border-gray-300 pt-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-lg font-semibold">
                  <div className="bg-green-50 p-4 rounded-lg">
                    <p className="text-gray-700">Total Income:</p>
                    <p className="text-2xl text-green-600">KSh {statement.totalIncome.toLocaleString()}</p>
                  </div>
                  <div className="bg-red-50 p-4 rounded-lg">
                    <p className="text-gray-700">Total Expenses:</p>
                    <p className="text-2xl text-red-600">KSh {statement.totalExpenses.toLocaleString()}</p>
                  </div>
                  <div className={`p-4 rounded-lg ${statement.netProfit >= 0 ? 'bg-blue-50' : 'bg-orange-50'}`}>
                    <p className="text-gray-700">Net Profit/Loss:</p>
                    <p className={`text-2xl ${statement.netProfit >= 0 ? 'text-blue-600' : 'text-orange-600'}`}>
                      KSh {statement.netProfit.toLocaleString()}
                    </p>
                  </div>
                </div>
                {selectedTruck && selectedTruck !== 'All Trucks' && (
                  <div className="mt-4 p-3 bg-blue-50 rounded-lg">
                    <p className="text-center text-blue-700 font-semibold">
                      This financial summary is for the selected truck only: {getTruckDisplayName(selectedTruck)}
                    </p>
                  </div>
                )}
              </div>
            </>
          )}

          {/* Customer Statement */}
          {statement.type === 'Customer' && (
            <>
              <div className="mb-8">
                <h3 className="text-xl font-bold mb-4">Deliveries</h3>
                {statement.deliveries.length === 0 ? (
                  <p className="text-gray-500 text-center py-4 bg-gray-50 rounded-lg">
                    No deliveries found for this customer
                    {selectedTruck && selectedTruck !== 'All Trucks' && (
                      <span className="block mt-2">and truck: {getTruckDisplayName(selectedTruck)}</span>
                    )}
                  </p>
                ) : (
                  <div className="overflow-x-auto">
                    <table className="min-w-full border-collapse border border-gray-300">
                      <thead className="bg-gray-100">
                        <tr>
                          <th className="border border-gray-300 px-4 py-2 text-left">Date</th>
                          <th className="border border-gray-300 px-4 py-2 text-left">Vehicle</th>
                          <th className="border border-gray-300 px-4 py-2 text-left">Route</th>
                          <th className="border border-gray-300 px-4 py-2 text-left">Bank</th>
                          <th className="border border-gray-300 px-4 py-2 text-left">Description</th>
                          <th className="border border-gray-300 px-4 py-2 text-right">Amount(KSh)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {statement.deliveries.map((d) => (
                          <tr key={d.id} className="hover:bg-gray-50">
                            <td className="border border-gray-300 px-4 py-2">{new Date(d.date).toLocaleDateString()}</td>
                            <td className="border border-gray-300 px-4 py-2">{d.vehicles?.plate_no || 'N/A'}</td>
                            <td className="border border-gray-300 px-4 py-2">{d.from} → {d.to}</td>
                            <td className="border border-gray-300 px-4 py-2">{d.bank || '-'}</td>
                            <td className="border border-gray-300 px-4 py-2">{d.description || '-'}</td>
                            <td className="border border-gray-300 px-4 py-2 text-right font-semibold">
                              {parseFloat(d.amount).toLocaleString()}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      {selectedTruck && selectedTruck !== 'All Trucks' && statement.deliveries.length > 0 && (
                        <tfoot>
                          <tr className="bg-blue-50">
                            <td colSpan="6" className="border border-gray-300 px-4 py-2 text-center text-blue-700 font-semibold">
                              Showing {statement.deliveries.length} delivery(ies) for customer "{selectedCustomer}" and truck: {getTruckDisplayName(selectedTruck)}
                            </td>
                          </tr>
                        </tfoot>
                      )}
                    </table>
                  </div>
                )}
              </div>

              <div className="border-t-2 border-gray-300 pt-4">
                <div className="bg-blue-50 p-6 rounded-lg">
                  <p className="text-xl text-gray-700 mb-2">Total Amount:</p>
                  <p className="text-3xl font-bold text-blue-600">KSh {statement.totalAmount.toLocaleString()}</p>
                  {selectedTruck && selectedTruck !== 'All Trucks' && (
                    <p className="text-sm text-blue-700 mt-2">
                      This total is for customer "{selectedCustomer}" filtered by truck: {getTruckDisplayName(selectedTruck)}
                    </p>
                  )}
                </div>
              </div>
            </>
          )}

          {/* Supplier Statement */}
          {statement.type === 'Supplier' && (
            <>
              <div className="mb-8">
                <h3 className="text-xl font-bold mb-4">Expenses</h3>
                {statement.expenses.length === 0 ? (
                  <p className="text-gray-500 text-center py-4 bg-gray-50 rounded-lg">
                    No expenses found for this supplier
                    {selectedTruck && selectedTruck !== 'All Trucks' && (
                      <span className="block mt-2">and truck: {getTruckDisplayName(selectedTruck)}</span>
                    )}
                  </p>
                ) : (
                  <div className="overflow-x-auto">
                    <table className="min-w-full border-collapse border border-gray-300">
                      <thead className="bg-gray-100">
                        <tr>
                          <th className="border border-gray-300 px-4 py-2 text-left">Date</th>
                          <th className="border border-gray-300 px-4 py-2 text-left">Vehicle</th>
                          <th className="border border-gray-300 px-4 py-2 text-left">Bank</th>
                          <th className="border border-gray-300 px-4 py-2 text-left">Description</th>
                          <th className="border border-gray-300 px-4 py-2 text-right">Amount(KSh)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {statement.expenses.map((e) => (
                          <tr key={e.id} className="hover:bg-gray-50">
                            <td className="border border-gray-300 px-4 py-2">{new Date(e.date).toLocaleDateString()}</td>
                            <td className="border border-gray-300 px-4 py-2">{e.vehicles?.plate_no || 'N/A'}</td>
                            <td className="border border-gray-300 px-4 py-2">{e.bank || '-'}</td>
                            <td className="border border-gray-300 px-4 py-2">{e.description || '-'}</td>
                            <td className="border border-gray-300 px-4 py-2 text-right font-semibold">
                              {parseFloat(e.amount).toLocaleString()}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      {selectedTruck && selectedTruck !== 'All Trucks' && statement.expenses.length > 0 && (
                        <tfoot>
                          <tr className="bg-blue-50">
                            <td colSpan="5" className="border border-gray-300 px-4 py-2 text-center text-blue-700 font-semibold">
                              Showing {statement.expenses.length} expense(s) for supplier "{selectedSupplier}" and truck: {getTruckDisplayName(selectedTruck)}
                            </td>
                          </tr>
                        </tfoot>
                      )}
                    </table>
                  </div>
                )}
              </div>

              <div className="border-t-2 border-gray-300 pt-4">
                <div className="bg-red-50 p-6 rounded-lg">
                  <p className="text-xl text-gray-700 mb-2">Total Amount Paid:</p>
                  <p className="text-3xl font-bold text-red-600">KSh{statement.totalAmount.toLocaleString()}</p>
                  {selectedTruck && selectedTruck !== 'All Trucks' && (
                    <p className="text-sm text-red-700 mt-2">
                      This total is for supplier "{selectedSupplier}" filtered by truck: {getTruckDisplayName(selectedTruck)}
                    </p>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      )}

      <style>{`
        @media print {
          body * {
            visibility: hidden;
          }
          #statement-content, #statement-content * {
            visibility: visible;
          }
          #statement-content {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            box-shadow: none;
            background: white;
            padding: 20px;
          }
          .no-print {
            display: none !important;
          }
        }
      `}</style>
    </div>
  );
}

export default Statements;